import { Box, FormControlLabel, Grid, MenuItem, Radio, Select, TextField } from "@mui/material";
import * as React from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { InstantMessageChannelMessageExpirationTime, InstantMessageChannelUserActiveState, InstantMessageChannelUserType } from "ui/Scripts/source/models/enums";
import { IInstantMessageChannelAddedUser, InstantMessageChannelAddedUser } from "ui/Scripts/source/models/instantMessage/instantMessageChannelAddedUser";
import { InstantMessageChannelHelper } from "ui/Scripts/source/models/instantMessage/instantMessageChannelHelper";
import { IInstantMessageChannelNew } from "ui/Scripts/source/models/instantMessage/instantMessageChannelNew";
import { IInstantMessageChannelEditUserItem, InstantMessageChannelEditUserItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelUserEditItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import * as instantMessageChannelService from "../../../models/services/instantMessageChannelService";
import { ISessionState } from "../../../models/session/sessionState";
import { IUserListItem } from "../../../models/user/userListItem";
import { UserListItems } from "../../../models/user/userListItems";
import { Dialog } from "../../framework/Dialog/Dialog";
import { FormSectionTitle } from "../../framework/Form/FormSectionTitle";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { SelectUserList } from "../../user/SelectUserList/SelectUserList";
import { IInstantMessageChannelSaveState, InstantMessageChannelEditDialog } from "../InstantMessageChannelEditDialog";
import { InstantMessageChannelEditDialogUserList } from "../InstantMessageChannelEditDialogUserList";

/* eslint-disable no-unused-vars */
const enum NewInstantMessageChannelType {
    OneToOne = "1",
    Internal = "2",
    External = "3"
}

const enum NewInstantMessageChannelDialogPage {
    Selection = "1",
    General = "2",
    Users = "3",
    User = "4"
}
/* eslint-enable no-unused-vars */

//InstantMessageChannelEditNewDialog
export interface IInstantMessageChannelEditNewDialogProp {
    classes?: string;
    sessionState: ISessionState;
    companyId: string;
    onOk: (instantMessageChannelId: string) => void;
    onCancel: () => void;
}

export interface IInstantMessageChannelEditNewDialogState extends IInstantMessageChannelSaveState {
    page: NewInstantMessageChannelDialogPage;
    channelNew: IInstantMessageChannelNew;
    // Selection
    channelType: NewInstantMessageChannelType;
    // General
    messageExpirationTimes: INumberTitle[];
    picture: string;
    // Users
    channelUsers: IInstantMessageChannelEditUserItem[];
    users: IUserListItem[]
}

export class InstantMessageChannelEditNewDialog extends React.Component<IInstantMessageChannelEditNewDialogProp, IInstantMessageChannelEditNewDialogState> {
    getStateFromProps = (props: IInstantMessageChannelEditNewDialogProp): IInstantMessageChannelEditNewDialogState => {
        return {
            page: NewInstantMessageChannelDialogPage.Selection,
            channelNew: null,
            // Selection
            channelType: NewInstantMessageChannelType.OneToOne,
            // General
            messageExpirationTimes: [
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.Quarter, "3 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.HalfYear, "6 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.Year, "12 " + Translations.Months),
                NumberTitle.createNumberTitle(InstantMessageChannelMessageExpirationTime.None, Translations.Unlimited)
            ],
            companyId: props.companyId,
            id: "",
            code: "",
            file: null,
            picture: "",
            resetPicture: false,
            comment: "",
            messageExpirationTime: 0,
            oneToOneChannel: true,
            internalChannel: true,
            activeState: 1,
            archivingType: 0,
            archivingRemoveDate: "",
            rowId: "",
            // Users
            channelUsers: [],
            users: [],
        };
    };

    constructor(props: IInstantMessageChannelEditNewDialogProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        //this.orgStateHash = this.getHashFromState(this.state);
    }

    async componentDidMount(): Promise<void> {
        const props = this.props;
        const channelNew = await AppUtils.callService(() => instantMessageChannelService.getInstantMessageChannelNew(props.companyId), false, false);
        if (!channelNew) return;
        this.setState({
            channelNew,
            messageExpirationTime: channelNew.instantMessageChannel.messageExpirationTime,
            internalChannel: channelNew.instantMessageChannel.internalChannel,
            activeState: channelNew.instantMessageChannel.activeState
        });
    }

    // #region Selection
    handleChangeChannelType = (checked: boolean, channelType: NewInstantMessageChannelType) => {
        if (!checked) return;
        this.setState({
            channelType,
            internalChannel: channelType !== NewInstantMessageChannelType.External,
            oneToOneChannel: channelType === NewInstantMessageChannelType.OneToOne,
        });
    };
    // #endregion Selection

    // #region General
    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "xts") {
            this.setState({ code: value });
        } else if (name === "comment") {
            this.setState({ comment: value });
        } else if (name === "messageExpirationTime") {
            this.setState({ messageExpirationTime: value.toInteger() });
        }
    };

    handleSetPicture = async (file: File) => {
        if (!file) return;
        const attachment = await FileAttachment.fileToFileAttachment(file, 0);
        if (!attachment) return;
        if (!AppUtils.validateFileAttachment(attachment)) return;
        this.setState({ file: attachment, resetPicture: false, picture: attachment.thumbnail });
    };

    handleRemovePicture = () => {
        this.setState({ file: null, resetPicture: true, picture: "" });
    };

    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (state.channelType !== NewInstantMessageChannelType.OneToOne && !state.code) {
                AppUtils.showErrorMessage(Translations.NameMustBeDefined);
                return resolve(false);
            }
            return resolve(true);
        });
    };
    // #endregion General

    // #region Users
    handleUsersRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            channelUsers: this.state.channelUsers.filter(i => ids.indexOf(i.id) < 0)
        });
    };
    
    modifyUsers = (companyId :string, newUsers: IUserListItem[], addedUsers: IInstantMessageChannelAddedUser[], removeUsers: boolean) => {
        const props = this.props;
        const state = this.state;
        const channelUsers = removeUsers ? [] : state.channelUsers.slice(0);
        const users = removeUsers ? [] : state.users.slice(0);
        let internalChannel = removeUsers ? true : state.internalChannel;
        if (newUsers && newUsers.length > 0) {
            for (const newUser of newUsers) {
                const addedUser = addedUsers.find(i => i.userId === newUser.id);
                if (!addedUser) continue;
                const newChannelUser = new InstantMessageChannelEditUserItem();
                newChannelUser.id = addedUser.id;
                newChannelUser.companyId = companyId;
                newChannelUser.userType = InstantMessageChannelUserType.User;
                newChannelUser.userCode = newUser.code;
                newChannelUser.firstName = newUser.firstName;
                newChannelUser.lastName = newUser.lastName;
                newChannelUser.picture = newUser.picture;
                newChannelUser.activeState = addedUser.activeState;
                channelUsers.push(newChannelUser);
                users.push(newUser);
                if (internalChannel && newChannelUser.companyId !== props.companyId) {
                    internalChannel = false;
                }
            }
        }
        this.setState({
            channelUsers,
            users,
            internalChannel
        });
    };

    handleUsersAdded = (companyId :string, newUsers: IUserListItem[], addedUsers: IInstantMessageChannelAddedUser[]) => {
        this.modifyUsers(companyId, newUsers, addedUsers, false);
    };

    handleUserSelect = async (users: IUserListItem[], companyId :string) => {
        if (!users || users.length < 1) return;
        this.modifyUsers(companyId, users, users.map(i => InstantMessageChannelAddedUser.createInstantMessageChannelAddedUser(Base.getGuid(), i.id, InstantMessageChannelUserActiveState.Invited)), true);
    };
    
    handleGetUserSelectListItems = (companyId: string, pageSize: number, page: number, filter: string,
        ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, _ignoreQrCodeUsers: boolean, _requireQrCodeUsers: boolean,
        doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
        return instantMessageChannelService.instantMessageChannelGetSelectUserListItems(this.props.companyId, Base.emptyGuid, companyId, pageSize, page, filter,
            ignoreUserIds, ignoreUserCodes, activityState, ignoreRecordUserConnected, doNotIgnoreRecordUserConnectedUserCode, sortColumn, sortOrderIsAsc);
    };
    // #endregion Users
    
    handleMoveToPreviousPage = () => {
        const state = this.state;
        const page = state.page === NewInstantMessageChannelDialogPage.Users
            ? NewInstantMessageChannelDialogPage.General
            : NewInstantMessageChannelDialogPage.Selection;
        const removeUsers = page === NewInstantMessageChannelDialogPage.Selection;
        const channelUsers = removeUsers ? [] : state.channelUsers.slice(0);
        const users = removeUsers ? [] : state.users.slice(0);
        this.setState({
            page,
            channelUsers,
            users
        });
    };

    handleMoveToNextPage = async () => {
        const state = this.state;
        if (state.page === NewInstantMessageChannelDialogPage.General) {
            if (!await AppUtils.validate(this.checkErrors)) return;
        }
        const page = state.page === NewInstantMessageChannelDialogPage.Selection
            ? (state.channelType === NewInstantMessageChannelType.OneToOne
                ? NewInstantMessageChannelDialogPage.User
                : NewInstantMessageChannelDialogPage.General)
            : NewInstantMessageChannelDialogPage.Users;
        const internalChannel = state.page === NewInstantMessageChannelDialogPage.Selection
            ? state.channelType !== NewInstantMessageChannelType.External
            : state.internalChannel;
        this.setState({
            page,
            internalChannel
        });
    };

    handleSave = async () => {
        const state = this.state;
        const props = this.props;
        if (!await AppUtils.validate(this.checkErrors)) return;
        const result = await InstantMessageChannelEditDialog.saveInstantMessageChannel({ ...state, companyId: props.companyId }, !state.code ? Translations.NewInstantMessageChannel : null, state.users.map(i => i.id));
        if (!result) return;
        props.onOk(this.state.id);
    };

    handleCancel = async () => {
        this.props.onCancel();
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.channelNew) return null;
        const hasPartners = state.channelNew.companies.length > 1;
        const nextButtonMode = state.page !== NewInstantMessageChannelDialogPage.User && state.page !== NewInstantMessageChannelDialogPage.Users;
        return (
            <Dialog
                id="instant-message-channel-edit-new-dialog"
                maxWidth={state.page === NewInstantMessageChannelDialogPage.Selection ? "sm" : "md"}
                maxHeight={state.page === NewInstantMessageChannelDialogPage.Selection ? undefined : "694px"}
                title={Translations.NewInstantMessageChannel}
                body={
                    <>
                        {state.page === NewInstantMessageChannelDialogPage.Selection &&
                            <>
                                <GridRow>
                                    <Grid item xs>
                                        <GridRow>
                                            <Grid item xs>
                                                <FormSectionTitle margin={0}>{Translations.SelectInstantMessageChannelType}</FormSectionTitle>
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item xs>
                                                <FormControlLabel
                                                    label={Translations.InstantMessageChannelOneUser}
                                                    control={
                                                        <Radio
                                                            checked={state.channelType === NewInstantMessageChannelType.OneToOne}
                                                            onChange={(_e, checked: boolean) => this.handleChangeChannelType(checked, NewInstantMessageChannelType.OneToOne)}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item xs>
                                                <FormControlLabel
                                                    label={Translations.InstantMessageChannelGroupInternal}
                                                    control={
                                                        <Radio
                                                            checked={state.channelType === NewInstantMessageChannelType.Internal}
                                                            onChange={(_e, checked: boolean) => this.handleChangeChannelType(checked, NewInstantMessageChannelType.Internal)}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </GridRow>
                                        <GridRow>
                                            <Grid item xs>
                                                <FormControlLabel
                                                    label={Translations.InstantMessageChannelGroupExternal}
                                                    hidden={!hasPartners}
                                                    control={
                                                        <Radio
                                                            checked={state.channelType === NewInstantMessageChannelType.External}
                                                            onChange={(_e, checked: boolean) => this.handleChangeChannelType(checked, NewInstantMessageChannelType.External)}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </GridRow>
                                    </Grid>
                                </GridRow>
                            </>
                        }
                        {state.page === NewInstantMessageChannelDialogPage.General &&
                            <>
                                <GridRow>
                                    <Grid item sm={12}>
                                        <Box display="flex" alignItems="flex-end">
                                            <AvatarImage
                                                id={InstantMessageChannelHelper.getAvatarId(state.channelUsers, state.picture, props.sessionState.code)}
                                                name={state.code}
                                                image={InstantMessageChannelHelper.getPicture(state.channelUsers, state.picture, props.sessionState.code)}
                                                // imageClass={InstantMessageChannelHelper.getPictureClass(state.channelUsers, state.picture, props.sessionState.code)}
                                                marginRight="1.5rem"
                                                size={60}
                                                editable={true}
                                                tooltip={Translations.CkickToChangeThePicture}
                                                removeTooltip={Translations.RemovePicture}
                                                onChange={this.handleSetPicture}
                                                onClear={state.resetPicture ? null : this.handleRemovePicture}
                                                onError={(message) => AppUtils.showErrorMessage(message)}
                                            />
                                            <FormField title={Translations.Name} required margin={0}>
                                                <TextField type="text" name="xts" title={Translations.Name} inputProps={{ maxLength: 50 }} value={state.code} onChange={this.handleChange} />
                                            </FormField>
                                        </Box>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item sm={12}>
                                        <FormField title={Translations.MessagePreservationTime} required>
                                            <Select name="messageExpirationTime" title={Translations.MessagePreservationTime} value={state.messageExpirationTime.toString(10)} onChange={this.handleChange}>
                                                {state.messageExpirationTimes.map((messageExpirationTime) =>
                                                    <MenuItem key={messageExpirationTime.number} value={messageExpirationTime.number.toString(10)}>{messageExpirationTime.title}</MenuItem>
                                                )}
                                            </Select>
                                        </FormField>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item sm={12}>
                                        <FormField title={Translations.Description}>
                                            <TextField name="comment" title={Translations.Description} inputProps={{ maxLength: 500 }} multiline minRows={5} value={state.comment} required={true} onChange={this.handleChange} />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                            </>
                        }
                        {state.page === NewInstantMessageChannelDialogPage.Users &&
                            <InstantMessageChannelEditDialogUserList
                                isReadOnly={false}
                                newChannelWizard={true}
                                sessionState={props.sessionState}
                                instantMessageChannelId={state.id}
                                instantMessageChannelCompanyId={props.companyId}
                                companies={state.channelType === NewInstantMessageChannelType.External ? state.channelNew.companies : [state.channelNew.companies[0]]}
                                users={state.channelUsers}
                                onRemoved={this.handleUsersRemoved}
                                onAdded={this.handleUsersAdded}
                                onUserTypeUpdated={null}
                            />
                        }
                        {state.page === NewInstantMessageChannelDialogPage.User &&
                            <SelectUserList
                                title={Translations.SelectInstantMessageChannelUser}
                                companies={state.channelNew.companies}
                                ignoreUserIds={[props.sessionState.id]}
                                ignoreUserCodes={state.channelNew.existingTwoPersonChannelPartnerUserCodes}
                                selectedIds={state.users.map(i => i.id)}
                                showUserGroupsCompanyId={props.companyId}
                                onSelect={this.handleUserSelect}
                                onGetUserSelectListItems={this.handleGetUserSelectListItems}
                            />
                        }
                    </>
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.Previous, variant: "outlined", onClick: state.page === NewInstantMessageChannelDialogPage.Selection ? null : this.handleMoveToPreviousPage },
                    {
                        title: nextButtonMode ? Translations.Next : Translations.Save,
                        variant: "confirmation",
                        onClick: nextButtonMode ? this.handleMoveToNextPage : this.handleSave
                    },
                ]}
                onClose={this.handleCancel}/>
        );
    }
}